class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.formInView = true;
    this.footerInView = false;
    this.formObserver = null;
    this.footerObserver = null;
    this.headerObserver = null;
    this.contentObserver = null;
    this.headerOffset = 0;
    this.buttonPassed = false;
    this.isProductPage = false;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.content = this.querySelector('.sticky-add-to-cart__content');
    this.isProductPage = document.body.classList.contains('mb-template-product');

    if (!this.form || !this.content) return;

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObservers();
      if (this.isProductPage) {
        this.contentObserver = new ResizeObserver(() => {
          if (this.dataset.active !== 'true' && this.dataset.closing !== 'true') {
            this.style.minHeight = `${this.content.offsetHeight}px`;
          }
          document.documentElement.style.setProperty('--mb-product-purchase-space', `${this.content.offsetHeight}px`);
        });
        this.contentObserver.observe(this.content);
        const header = document.querySelector('.section-header');
        if (header) {
          this.headerObserver = new ResizeObserver(() => this.#observePurchaseButton());
          this.headerObserver.observe(header);
        }
      }
    });
  }

  disconnectedCallback() {
    this.formObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.headerObserver?.disconnect();
    this.contentObserver?.disconnect();
    clearTimeout(this.closingTimeout);
  }

  #initObservers() {
    if (this.isProductPage) {
      this.#observePurchaseButton();
    } else {
      this.formObserver = new IntersectionObserver(([entry]) => {
        this.formInView = entry.isIntersecting;
        this.#updateDisplay();
      });
      this.formObserver.observe(this.form);
    }

    if (!this.footer) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.footerObserver.observe(this.footer);
  }

  #observePurchaseButton() {
    this.formObserver?.disconnect();
    const header = document.querySelector('.section-header');
    this.headerOffset = header && getComputedStyle(header).position === 'sticky'
      ? header.getBoundingClientRect().height : 0;
    // Observe the reserved space, not the fixed button: its position stays stable.
    this.formObserver = new IntersectionObserver(([entry]) => {
      this.buttonPassed = entry.boundingClientRect.bottom <= this.headerOffset;
      this.#updateDisplay();
    }, { rootMargin: `-${this.headerOffset}px 0px 0px 0px`, threshold: [0, 1] });
    this.formObserver.observe(this);
  }

  #updateDisplay() {
    const shouldBeActive = (this.isProductPage ? this.buttonPassed : !this.formInView) && !this.footerInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
